(ns frontend.view.modals.folder-management-check-lists-modal.sub
  (:require
   [clojure.data :as data]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::selected-check-lists
 (fn [db]
   (get db ::selected-check-lists)))

(rf/reg-sub
 ::selected
 :<-
 [::selected-check-lists]
 (fn [selected-check-lists [_ list-id]]
   (some #{list-id} selected-check-lists)))

(rf/reg-sub
 ::original-list-ids
 (fn [db]
   (get db ::original-list-ids)))

(rf/reg-sub
 ::target-entity-type
 (fn [db]
   (get db ::target-entity-type)))
(rf/reg-sub
 ::edit-list-original
 (fn [db]
   (get db ::edit-list-original)))

(rf/reg-sub
 ::edit-list
 (fn [db]
   (get db ::edit-list)))

(rf/reg-sub
 ::edit-list-configuration
 :<-
 [::edit-list]
 (fn [list _]
   (get list :check-list/configuration)))

(rf/reg-sub
 ::edit-list-sorted-fields
 :<-
 [::edit-list-configuration]
 (fn [config [_]]
   (some->> config
            (map-indexed (fn [idx field]
                           {:id    idx
                            :field field})))))

(def system-boolean-fields
  [:common/disabled?
   :common/archived?
   :common/gift-sample?
   :common/zap-sample?
   :common/zap-migrated?])

(rf/reg-sub
 ::selectable-field-options
 :<-
 [::edit-list-sorted-fields]
 :<-
 [::target-entity-type]
 (fn [[selected-fields target-entity-type] _]
   (let [fields (registry/get-schema @session/tenant-schema target-entity-type)
         field-keys (map :field selected-fields)
         tenant-fields-in-use (set (:tenant/fields-in-use @session/tenant))]
     (let [fields (->> fields
                       (keep (fn [[f fs]]
                               (when (and
                                      (not (some #{f} system-boolean-fields))
                                      (some #{f} tenant-fields-in-use)
                                      (= :data.type/boolean (:field/data-type fs))
                                      (not (some #{f} field-keys)))
                                 {:value f
                                  :label (loc/field-name f fs)})))
                       (sort-by (fn [{:keys [label]}]
                                  (cu/str-trim-lcase label))))]
       fields))))

(rf/reg-sub
 ::changes?
 :<-
 [::selected-check-lists]
 :<-
 [::original-list-ids]
 (fn [[selected original] [_]]
   (let [[added removed old] (data/diff (set selected) (set original))]
     (or (seq added)
         (seq removed)))))

(rf/reg-sub
 ::processing?
 (fn [db]
   (get db ::processing?)))

(rf/reg-sub
 ::target-entity-id
 (fn [db]
   (get db ::target-entity-id)))

(rf/reg-sub
 ::edit-changes?
 :<-
 [::edit-list]
 :<-
 [::edit-list-original]
 (fn [[modified original] _]
   (let [[modified removed common] (data/diff modified original)]
     (or (seq modified)
         (seq removed)))))
